export default {
    current_choice: 'Trenutačni izbor',
    book_now: 'Izvrši rezervaciju',
    minimum_age: 'Samo za osobe preko {age} godina',
    excess_liability: 'Povećano pokriće',
    security_deposit: 'Jamstveni polog',
    fuel_policy: 'Pravilo količine goriva',
    like_for_like: 'Koliko dobiješ toliko vraćaš',
    full_to_full: 'Dobiven i vraćen puni spremnik',
    miles_per_rental: '{mileage} besplatnih milja po najmu',
    km_per_rental: '{mileage} besplatnih kilometara po najmu',
    unlimited_mileage: 'Neograničeno milja',
    unlimited_mileage_km: 'Neograničeno kilometara',
    non_amendable: 'Neizmjenjivo',
    non_refundable: 'Bespovratno',
    free_cancellation_until: 'Besplatno odustajanje do',
    cancellation_in_line_with: 'Odustajanje u skladu s',
    tcs: 'Uvjetima i odredbama',
    free_extras_on_collection: 'Dva besplatna dodatka prilikom preuzimanja',
    glass_and_tyres_covered: 'Pokriće za stakla i gume',
    number_of_passengers: 'Broj putnika',
    number_of_bags: 'Broj torbi',
    fuel_type: 'Vrsta goriva',
    co2: 'CO2',
    aircon: 'Air Con',
    transmission: 'Sustav prijenosa',
    book_type: 'Rezerviraj {type}',
    debit_card_deposit: 'Debitna kartica prihvaćena za depozite',
    fast_track_included: 'Uključena brza staza',
}
